import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    ChevronDown as ChevronDownIcon
} from "lucide-react-native";

const PreferenceChevronIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => {
    return <ChevronDownIcon
        color={customColor}
        size={size}
    />;
};
export default PreferenceChevronIcon;
